<template>
  <div
    class="LmBackdrop"
    :class="{'is-open': open}"
    @click="$emit('click', $event)"
  />
</template>

<script>
export default {
  name: 'LmBackdrop',
  props: {
    open: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style scoped>
.LmBackdrop {
  &.is-open {
    opacity: 1;
    pointer-events: auto;
  }
  position: absolute;
  width: 100vw;
  height: 100vh;
  z-index: 1;
  pointer-events: none;
  background-color: theme('backgroundColor.backdrop');
  opacity: 0;
  transition: all 0.5s cubic-bezier(0.35, 0, 0.25, 1);
  transition-property: opacity;
  will-change: opacity;
}
</style>
